import React from 'react'
import { useRouter } from 'next/router'

import { useAPIGetPraktikKinerjaFormValues } from 'api/kinerja/pengawas-sekolah/pelaksanaan/form'

import type { StatusPelaksanaanPraktikKinerja } from 'types/kinerja-ps-pegawai'

type TPelaksanaanPraktikKinerja = {
  state: StatusPelaksanaanPraktikKinerja
}
export const usePelaksanaanPraktikKinerja = ({
  state,
}: TPelaksanaanPraktikKinerja): any => {
  const router = useRouter()
  const skpPsId = router.query?.skpPsId as string
  const { data: diskusiPersiapanFormData, isLoading: diskusiPersiapanLoading } =
    useAPIGetPraktikKinerjaFormValues({
      skpPsId,
      formName: 'diskusi_persiapan',
      opts: {
        enabled:
          Boolean(skpPsId) &&
          ['DISKUSI_PERSIAPAN', 'PENDAMPINGAN_SEKOLAH'].includes(state),
      },
    })
  const isDiskusiPersiapanFormSubmitted = React.useMemo(
    () =>
      Object.keys(JSON.parse(diskusiPersiapanFormData?.formValues ?? '{}'))
        .length > 0,
    [diskusiPersiapanFormData?.formValues]
  )

  const {
    data: pendampinganSekolahFormData,
    isLoading: pendampinganSekolahLoading,
  } = useAPIGetPraktikKinerjaFormValues({
    skpPsId,
    formName: 'pendampingan_sekolah',
    opts: {
      enabled:
        Boolean(skpPsId) &&
        ['DISKUSI_PERSIAPAN', 'PENDAMPINGAN_SEKOLAH'].includes(state),
    },
  })
  const isPendampinganSekolahFormSubmitted = React.useMemo(
    () =>
      Object.keys(JSON.parse(pendampinganSekolahFormData?.formValues ?? '{}'))
        .length > 0,
    [pendampinganSekolahFormData?.formValues]
  )

  const isLoading = React.useMemo(
    () => diskusiPersiapanLoading || pendampinganSekolahLoading,
    [diskusiPersiapanLoading, pendampinganSekolahLoading]
  )

  return {
    isDiskusiPersiapanFormSubmitted,
    isPendampinganSekolahFormSubmitted,

    diskusiPersiapanLoading,
    pendampinganSekolahLoading,
    isLoading,
  }
}
